import React, { useEffect } from "react";
import Dropdown from "components/dropdown";
import { FiAlignJustify, FiLogOut, FiUser, FiLock } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import Switch from "@mui/material/Switch";
import avatar from "assets/img/avatars/avatar4.png";
import { getUser, removeToken } from "auth/Authentication";
import { checkAuthenticateLogin, logoutUser, updatetDataById } from "api";
import { users } from "api/collection_names";
import { Box } from "@mui/material";
import AppSnackbar from "components/snakbar";
import { SnackbarState, CustomThemeColors, CustomThemeModes } from "models/user-models";
import { applyTheme, buildCustomCssVars, ThemeMode } from "theme/themeData";
import { RiMoonFill, RiSunFill } from "react-icons/ri";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const Navbar = (props: {
  onOpenSidenav: () => void;
  brandText: string;
  path: string;
  secondary?: boolean | string;
}) => {
  const navigate = useNavigate();
  const { onOpenSidenav, brandText, path } = props;
  // const [darkmode, setDarkmode] = React.useState(false);
  const [snackbar, setSnackbar] = React.useState<SnackbarState>({
    open: false,
    message: "",
    severity: "info",
  });
  const [checked, setChecked] = React.useState<boolean>();
  const [user, setUser] = React.useState(null);
  const [themeMode, setThemeMode] = React.useState<ThemeMode>("light");
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [trialExpire, setTrialExpire] = React.useState(false);

  const handleLogout = async () => {
    const res = await logoutUser(user.email);
    removeToken();
  };
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
    loginAuth();
  };

  useEffect(() => {
    let local_user = getUser();
    setUser(local_user);
    setThemeMode(local_user?.themeMode || "light");
    const hasTrialExpired = (expirationTimeUTC: any) => {
      const currentTimeUTC = new Date().toISOString(); // Get current time in UTC
      return currentTimeUTC > expirationTimeUTC; // Compare current time with expiration time
    };
    if (hasTrialExpired(local_user.trial_expiry)) {
      setTrialExpire(true);
    }
  }, [navigate]);

  const handleThemeModeChange = async (mode: ThemeMode) => {
    setThemeMode(mode);
    const savedTheme = user?.customTheme as CustomThemeColors | CustomThemeModes | undefined;
    const savedColors = savedTheme && ("light" in savedTheme || "dark" in savedTheme)
      ? savedTheme[mode]
      : savedTheme;
    const customCssVars = user?.useCustomTheme && savedColors
      ? buildCustomCssVars(savedColors as Record<string, string>, mode)
      : undefined;
    applyTheme(user?.theme || "horizonDefault", customCssVars, mode);

    if (user?._id) {
      const updatedUser = { ...user, themeMode: mode };
      setUser(updatedUser);
      try {
        await updatetDataById(users, updatedUser, user._id);
      } catch (error) {
        console.error("Error saving theme mode:", error);
      }
    }
  };


  const loginAuth = async () => {
    const result = await checkAuthenticateLogin({ isLoginAuthenticate: !checked });
    if (result.success) {
      setSnackbar({ open: true, message: `${checked === true ? " OTP required disabled " : "OTP required enabled"}`, severity: "success" });
    }
  };


  useEffect(() => {
    const loginAuth = async () => {
      const result = await checkAuthenticateLogin({ getData: true });
      if (result.success) {
        setChecked(result.isLoginAuthenticate);
      }
    };
    loginAuth();
  }, [])

  return (
    <nav className="z-10 items-center justify-between rounded-xl">
      {/* <div className="ml-[6px]">
        <div className="flex h-6 w-[224px] pt-1">
          <p className="text-sm font-normal text-navy-700 dark:text-white">
            Pages
            <span className="mx-1 text-sm text-navy-700 hover:text-navy-700 dark:text-white">
              {" "}
              /{" "}
            </span>
          </p>
          <Link
            className="text-sm font-normal capitalize text-navy-700 hover:underline dark:text-white dark:hover:text-white"
            to="#"
          >
            {brandText}
          </Link>
        </div>

        <p className="shrink text-[33px] capitalize text-navy-700 dark:text-white">
          <Link
            to={path}
            className="font-bold capitalize hover:text-navy-700 dark:hover:text-white"
          >
            {brandText}
          </Link>
        </p>
      </div> */}

      <div className="fixed top-[0.5%] right-[0.5%] z-[9999] bg-surfacePrimary p-[5px] rounded-[100px] shadow-[0_4px_10px_var(--color-shadow-primary,rgba(0,0,0,0.15))]">
        {/* SEARCH */}
        {/* <div className="flex h-full items-center rounded-full bg-lightPrimary text-navy-700 dark:bg-navy-900 dark:text-white xl:w-[225px]">
          <p className="pl-3 pr-2 text-xl">
            <FiSearch className="h-4 w-4 text-gray-400 dark:text-white" />
          </p>
          <input
            type="text"
            placeholder="Search..."
            className="block h-full w-full rounded-full bg-lightPrimary text-sm font-medium text-navy-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white sm:w-fit"
          />
        </div> */}

        <span
          className="flex cursor-pointer text-xl text-gray-600 dark:text-white xl:hidden"
          onClick={onOpenSidenav}
        >
          <FiAlignJustify className="h-5 w-5" />
        </span>
        {/* start Notification */}
        {/* <Dropdown
          button={
            <p className="cursor-pointer">
              <IoMdNotificationsOutline className="h-4 w-4 text-gray-600 dark:text-white" />
            </p>
          }
          animation="origin-[65%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
          children={
            <div className="flex w-[360px] flex-col gap-3 rounded-[20px] bg-white p-4 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none sm:w-[460px]">
              <div className="flex items-center justify-between">
                <p className="text-base font-bold text-navy-700 dark:text-white">
                  Notification
                </p>
                <p className="text-sm font-bold text-navy-700 dark:text-white">
                  Mark all read
                </p>
              </div>

              <button className="flex w-full items-center">
                <div className="flex h-full w-[85px] items-center justify-center rounded-xl bg-gradient-to-b from-brandLinear to-brand-500 py-4 text-2xl text-white">
                  <BsArrowBarUp />
                </div>
                <div className="ml-2 flex h-full w-full flex-col justify-center rounded-lg px-1 text-sm">
                  <p className="mb-1 text-left text-base font-bold text-gray-900 dark:text-white">
                    New Update: Horizon UI Dashboard PRO
                  </p>
                  <p className="font-base text-left text-xs text-gray-900 dark:text-white">
                    A new update for your downloaded item is available!
                  </p>
                </div>
              </button>

              <button className="flex w-full items-center">
                <div className="flex h-full w-[85px] items-center justify-center rounded-xl bg-gradient-to-b from-brandLinear to-brand-500 py-4 text-2xl text-white">
                  <BsArrowBarUp />
                </div>
                <div className="ml-2 flex h-full w-full flex-col justify-center rounded-lg px-1 text-sm">
                  <p className="mb-1 text-left text-base font-bold text-gray-900 dark:text-white">
                    New Update: Horizon UI Dashboard PRO
                  </p>
                  <p className="font-base text-left text-xs text-gray-900 dark:text-white">
                    A new update for your downloaded item is available!
                  </p>
                </div>
              </button>
            </div>
          }
          classNames={"py-2 top-4 -left-[230px] md:-left-[440px] w-max"}
        /> */}
        {/* start Horizon PRO */}
        {/* <Dropdown
          button={
            <p className="cursor-pointer">
              <IoMdInformationCircleOutline className="h-4 w-4 text-gray-600 dark:text-white" />
            </p>
          }
          children={
            <div className="flex w-[350px] flex-col gap-2 rounded-[20px] bg-white p-4 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
              <div
                style={{
                  backgroundImage: `url(${navbarimage})`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                }}
                className="mb-2 aspect-video w-full rounded-lg"
              />
              <a
                target="blank"
                href="https://horizon-ui.com/pro?ref=live-free-tailwind-react"
                className="px-full linear flex cursor-pointer items-center justify-center rounded-xl bg-brand-500 py-[11px] font-bold text-white transition duration-200 hover:bg-brand-500/80 hover:text-white active:bg-brand-500/70 dark:bg-brand-400 dark:hover:bg-brand-400/80 dark:active:bg-brand-400/70"
              >
                Buy Horizon UI PRO
              </a>
              <a
                target="blank"
                href="https://horizon-ui.com/docs-tailwind/docs/react/installation?ref=live-free-tailwind-react"
                className="px-full linear flex cursor-pointer items-center justify-center rounded-xl border py-[11px] font-bold text-navy-700 transition duration-200 hover:bg-gray-200 hover:text-navy-700 dark:!border-white/10 dark:text-white dark:hover:bg-white/20 dark:hover:text-white dark:active:bg-white/10"
              >
                See Documentation
              </a>
              <a
                target="blank"
                href="https://horizon-ui.com/?ref=live-free-tailwind-react"
                className="hover:bg-black px-full linear flex cursor-pointer items-center justify-center rounded-xl py-[11px] font-bold text-navy-700 transition duration-200 hover:text-navy-700 dark:text-white dark:hover:text-white"
              >
                Try Horizon Free
              </a>
            </div>
          }
          classNames={"py-2 top-6 -left-[250px] md:-left-[330px] w-max"}
          animation="origin-[75%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
        /> */}

        {/* DARK MODE */}
        {/* <div
          className="cursor-pointer text-gray-600"
          onClick={() => {
            if (darkmode) {
              document.body.classList.remove("dark");
              setDarkmode(false);
            } else {
              document.body.classList.add("dark");
              setDarkmode(true);
            }
          }}
        >
          {darkmode ? (
            <RiSunFill className="h-4 w-4 text-gray-600 dark:text-white" />
          ) : (
            <RiMoonFill className="h-4 w-4 text-gray-600 dark:text-white" />
          )}
        </div> */}

        {/* Profile & Dropdown */}

        <Dropdown
          button={
            <img
              className="h-10 w-10 rounded-full border border-borderPrimary"
              src={avatar}
              alt="Elon Musk"
            />
          }
          children={
            <div className="m-h-40 pb-2 flex w-56 flex-col justify-start rounded-[20px] bg-surfacePrimary bg-cover bg-no-repeat shadow-xl border border-borderPrimary text-textPrimary">
              <div className="ml-4 mt-3">
                <div className="flex items-center gap-2">
                  <p className="text-sm font-bold text-textPrimary">
                    👋 Hi ,{" "}
                    <span className="capitalize">
                      {" "}
                      {user?.fname} {user?.lname}
                    </span>
                  </p>{" "}
                </div>
              </div>
              <div className="mt-3 h-px w-full bg-borderPrimary" />

              <div className="ml-4 mt-3 flex flex-col">
                <Link
                  to="/admin/profile"
                  className="flex gap-3 text-sm text-textPrimary hover:text-brand-500"
                >
                  <FiUser className="h-4 w-4" />
                  Profile Settings
                </Link>
              </div>
              <div className="ml-4 mt-3 flex flex-col">
                <Link
                  to="/admin/changePassword"
                  className="flex gap-3 text-sm text-textPrimary hover:text-brand-500"
                >
                  <FiLock className="h-4 w-4" />
                  Change Password
                </Link>
              </div>
              {user?.type === "1" && (
                <div className="ml-4 mt-3 flex flex-col">
                  <Box className="flex gap-3 text-sm text-textPrimary hover:text-brand-500">
                    <FiLock className="h-4 w-4" />
                    {checked ? "Deactivate OTP" : "Activate OTP"}
                    <Switch
                      checked={checked}
                      onChange={handleChange}
                      inputProps={{ "aria-label": "controlled" }}
                      size="small"
                    />
                  </Box>
                </div>
              )}
              <div className="ml-4 mt-2 flex flex-col">
                <div className="flex items-center justify-start pr-4  gap-3 text-sm text-textPrimary">
                  <span className="flex items-center gap-3">
                    {themeMode === "dark" ? <RiMoonFill className="h-4 w-4" /> : <RiSunFill className="h-4 w-4" />}
                    {themeMode === "dark" ? "Dark Theme" : "Light Theme"}
                  </span>
                 
                  <Switch
                      checked={themeMode === "dark"}
                      onChange={() => handleThemeModeChange(themeMode === "dark" ? "light" : "dark")}
                      inputProps={{ "aria-label": "controlled" }}
                      size="small"
                    />
                </div>


              </div>
              <div className="justify-end">
                <div className="mt-4 h-px w-full bg-borderPrimary" />
                <div className="ml-4 mt-2 flex flex-col" onClick={handleLogout}>
                  <Link
                    to="/auth"
                    className="flex items-center gap-3 text-sm text-[#ff0000] hover:text-[#ff0000]/80 active:text-[#ff0000]/70"
                  >
                    <FiLogOut className="h-4 w-4" />
                    Log Out
                  </Link>
                </div>
              </div>
            </div>
          }
          classNames={"py-2 top-8 -left-[180px] w-max"}
        />
      </div>
      <AppSnackbar
        isOpen={snackbar.open}
        title={snackbar.message}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        severity={snackbar.severity}
      />
    </nav>
  );
};

export default Navbar;
